import React, { useEffect, useRef } from 'react';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export default function withScrollHack(WrappedComponent, style = {}) {
  const ScrollTopHack = (props) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
      const setScrollTop = (e) => {
        const { current } = wrapperRef;
        if (current && current.scrollTop) {
          // && !Platform.supportsPreventScroll
          current.scrollTop = 0;
        }
        if (current && current.scrollLeft) {
          // && !Platform.supportsPreventScroll
          current.scrollLeft = 0;
        }
      };

      wrapperRef.current.addEventListener('scroll', setScrollTop);

      // eslint-disable-next-line react-hooks/exhaustive-deps
      return () => wrapperRef.current.removeEventListener('scroll', setScrollTop);
    }, []);

    return (
      <StyledWrapper ref={wrapperRef} style={style}>
        <WrappedComponent {...props} />
      </StyledWrapper>
    );
  };

  return ScrollTopHack;
}
